import { View } from './view'

export const BrokerSignContentWrapper = View
